import { render, staticRenderFns } from "./TasksView.vue?vue&type=template&id=6557f4cf&scoped=true&"
import script from "./TasksView.vue?vue&type=script&lang=js&"
export * from "./TasksView.vue?vue&type=script&lang=js&"
import style0 from "./TasksView.vue?vue&type=style&index=0&id=6557f4cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6557f4cf",
  null
  
)

component.options.__file = "TasksView.vue"
export default component.exports